const React = require("react");

require("./StatusMarker.less");

const StatusMarker = React.createClass({
    propTypes: {
        IsValid: React.PropTypes.bool
    },
    render() {
        if (this.props.IsValid) {
            return (<span className="glyphicon glyphicon-ok-sign cs-StatusMarker__good"></span>);
        }

        return (<span className="glyphicon glyphicon-exclamation-sign cs-StatusMarker__bad"></span>);
    }
});

module.exports = StatusMarker;


// WEBPACK FOOTER //
// ./src/components/SurveyNav/StatusMarker/StatusMarker.jsx